<template>
  <div>
    <the-mask
      type="text"
      mask="##############"
      :masked="true"
      :class="{
        'form-control': true,
        invalid: validationField.$error && !validations.result && !validations.partOne,
        warning: validations.partOne,
        success: validations.result && validations.partTwo
      }"
      v-model="pinflModel"
      @input="onInput"
      :placeholder="placeholder"
      :autofocus="autofocus"
      :disabled="disabled"
      :readonly="readonly"/>
    <div class="text-danger d-flex align-items-center mt-1" v-if="validationField.$error">
      <button class="btn btn-outline-danger btn-sm mr-2 shadow-none" @click="handleOpenImg"><i class="fa fa-exclamation-triangle"></i></button>
      ИНН ёки ЖШШИР формати хато
    </div>
    <b-modal v-model="showImg" size="md" title="" hide-footer centered>
      <div>
        <img :src="images.imageRu" class="w-100 h-100" v-if="language === 'ru'" />
        <img :src="images.imageUz" class="w-100 h-100" v-else/>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {TheMask} from 'vue-the-mask';
import {isValidPinfl} from "@/shared/pinfl-birthdate/pinfl-birthdate";
import images from "@/shared/pinfl-birthdate/images.json"
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
export default {
  name: "PinflInput",
  components: {
    'b-modal': bModal,
    TheMask
  },
  directives: {
    'b-modal': bModalDirective
  },
  props: {
    placeholder: String,
    className: String,
    pinfl: String,
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validationField: {
      type: Object,
      default: () => {
      }
    },
    withBirtDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pinflModel: {
      get() {
        return this.$props.pinfl
      },
      set(newValue) {
        this.$emit("update:pinfl", newValue)
      }
    },
    language() {
      return this.$i18n.locale
    }
  },
  data() {
    return {
      showImg: false,
      validations: {
        partOne: false,
        partTwo: false,
        result: false,
        pinflBirthDate: null
      },
      images: images
    }
  },
  methods: {
    onInput(value) {
      this.validations = isValidPinfl(value)
      if (this.$props.validationField) {
        this.$props.validationField.$touch()
      }
      if(this.$props.withBirtDate) {
        this.$emit('birth-date-complete-event', this.validations.pinflBirthDate)
      }
    },
    handleOpenImg() {
      this.showImg = true
    }
  }
}
</script>

<style scoped>
.form-control:focus.invalid {
  box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
}

.form-control:focus.warning {
  box-shadow: 0 0 0 0.2rem rgba(211,158,0,.5);
}

.form-control:focus.success {
  box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25);
}

.invalid {
  border: 1px solid #e53935 !important;
  border-radius: 4px !important;
}

.warning {
  border: 1px solid #d39e00 !important;
  border-radius: 4px !important;
}

.success {
  border: 1px solid #28a745 !important;
  border-radius: 4px !important;
}
</style>
